import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {AzPageHeader} from '../../components/AzPageHeader'
import { FooterListWrapper } from './FooterComponent'
import { LegalListWrapper } from './LegalComponent'
import { useIntl } from 'react-intl'

const FooterPage = () => {
  const intl = useIntl()

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='footer'
          element={
            <>
              <AzPageHeader title={intl.formatMessage({ id: 'FOOTER_MANAGEMENT.PAGE_HEADER_TITLE' })} />
              <FooterListWrapper/>
            </>
          }
        />
        <Route
          path='legal'
          element={
            <>
              <AzPageHeader title={intl.formatMessage({ id: 'LEGAL_MANAGEMENT.PAGE_HEADER_TITLE' })} />
              <LegalListWrapper />
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/footer-management/footer' />} />
    </Routes>
  )
}

export default FooterPage
